import { useTranslation } from "react-i18next";
import Box from "@cloudscape-design/components/box";
import Badge from "@cloudscape-design/components/badge";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";

function GatewayTargetTile({ target, isWriteUser, onEdit, onDelete, onSync }) {
  const { t } = useTranslation();

  const getStatusColor = (status) => {
    switch (status) {
      case "READY": return "green";
      case "CREATING":
      case "UPDATING":
      case "SYNCHRONIZING": return "blue";
      default: return "grey";
    }
  };

  const toolCount = target.tool_schema?.length || 0;

  return (
    <div 
      className="scenario-tile gateway-target-tile"
      role="article"
      aria-label={target.name}
    >
      <div className="scenario-tile-content">
        <SpaceBetween size="xs">
          <div className="scenario-tile-header">
            <Box variant="h3" fontSize="heading-m" fontWeight="bold">{target.name}</Box>
            <div className="scenario-tile-actions">
              {isWriteUser && (
                <>
                  <Button 
                    variant="icon" 
                    iconName="refresh" 
                    onClick={(e) => { e.stopPropagation(); onSync(target); }} 
                    ariaLabel={t("gateway-targets.tile.sync")} 
                  />
                  <Button 
                    variant="icon" 
                    iconName="edit" 
                    onClick={(e) => { e.stopPropagation(); onEdit(target); }} 
                    ariaLabel={t("gateway-targets.tile.edit")} 
                  />
                  <Button 
                    variant="icon" 
                    iconName="remove" 
                    onClick={(e) => { e.stopPropagation(); onDelete(target); }} 
                    ariaLabel={t("gateway-targets.tile.delete")} 
                  />
                </>
              )}
            </div>
          </div>
          <Box color="text-body-secondary" fontSize="body-s">
            {target.description || t("gateway-targets.tile.no_description")}
          </Box>
          <Box color="text-body-secondary" fontSize="body-s">
            {t("gateway-targets.tile.tools_count", { count: toolCount })}
          </Box>
          <div className="scenario-tile-footer">
            <SpaceBetween size="xs">
              {target.target_id && (
                <Box color="text-body-secondary" fontSize="body-s">
                  Target ID: {target.target_id}
                </Box>
              )}
              <Box color="text-body-secondary" fontSize="body-s">
                Status: <Badge color={getStatusColor(target.status)}>{target.status || "UNKNOWN"}</Badge>
              </Box>
            </SpaceBetween>
          </div>
        </SpaceBetween>
      </div>
    </div>
  );
}

export default GatewayTargetTile;
